import React, { useState, useEffect } from "react";
import Inputfield from "../../components/Textfield/Textfield";
import Buttons from "../../components/Button/Button";
import "../../components/Modal/Modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Auth } from "aws-amplify";
import { API, graphqlOperation } from "aws-amplify";
import Snackbar from "../../components/Snackbar/Snackbar";
import { login } from "../../store/action";
import { productById, byUserId } from "../../graphql/queries";
import { campaignData } from "../../store/action";
import { createUserInfo } from "../../graphql/mutations";
import { listUserInfos } from "../../graphql/queries";
import { Grid, Container } from "@mui/material";
import Logo from "../../assets/LAETUS.png";
import { UseWindowSize } from "../../hooks/Usewindow";
import "./Dashboard.scss";

export default function Authentication() {
	const logindata = useSelector((state) => state.login);
	const [auth, setauth] = useState("signin");
	const dispatch = useDispatch();
	const history = useHistory();
	const [email, setEmail] = useState("");
	const [emailerror, setEmailError] = useState(false);
	const [password, setpassword] = useState("");
	const [passwordError, setpasswordError] = useState(false);
	const [msg, setmsg] = useState("");
	const [errMsg, seterrMsg] = useState("");
	const [authstate, setAuthstate] = useState("auth");
	const [verifycode, setVerifycode] = useState("");
	const [loader1, setloader1] = useState(false);
	const [loader2, setloader2] = useState(false);
	const [code, setCode] = useState("");
	const [userName, setUsername] = useState("");
	const [userNameError, setUserNameError] = useState("");

	const { t } = useTranslation();
	const width = UseWindowSize();

	useEffect(() => {
		if (auth !== "signin" || email) {
			if (!email.includes("@") || !email.includes(".") || email.length < 5) {
				setEmailError(t("emailerror"));
			} else {
				setEmailError(t(""));
			}
		}
	}, [email]);
	useEffect(() => {
		if (auth !== "signin" || password) {
			if (password.length < 8) {
				setpasswordError(t("passworderror"));
			} else {
				setpasswordError(t(""));
			}
		}
	}, [password]);

	useEffect(() => {
		if (userName.length > 18) {
			setUserNameError(t("usernameerr"));
		} else {
			setUserNameError(t(""));
		}
	}, [userName]);

	async function signUp(e) {
		e.preventDefault();
		if (!emailerror && !passwordError && !userNameError) {
			setloader1(true);
			setmsg("");
			seterrMsg("");
			try {
				const Signup = await Auth.signUp({
					username: email,
					password: password,
				});
				if (Signup.user.username) {
					const user = {
						userId: Signup.userSub,
						userName: userName,
						email: email,
						paypalEmail: "",
						accountNo: "",
						ibanNo: "",
						WebflowCustomerId: "",
					};
					await API.post("laetusapi", "/api/v1/mailchimp", {
						body: {
							email: email,
							userName: userName,
						},
					});
					await API.graphql({
						query: createUserInfo,
						authMode: "API_KEY",
						variables: {
							input: user,
						},
					});
					setmsg(t("succesfully-sign"));
					setAuthstate("confirmation");
					setloader1(false);
					setTimeout(() => {
						setmsg("");
					}, 1500);
				}
			} catch (error) {
				seterrMsg(error.message);
				setloader1(false);
			}
		}
	}

	async function signIn(e) {
		e.preventDefault();
		setloader1(true);
		seterrMsg("");
		try {
			const user = await Auth.signIn(email, password);
			dispatch(
				login({
					loginStatus: true,
					userDetail: user.attributes.sub,
					email: user.attributes.email,
				}),
			);
			let nextTokens;
			let users;
			localStorage.setItem("email", user.attributes.sub);
			do {
				users = await API.graphql(
					graphqlOperation(byUserId, {
						userId: user.attributes.sub,
						nextTokens,
						limit: 500,
					}),
				);
				nextTokens = users.data.byUserId.nextToken;
			} while (nextTokens);
			dispatch(
				login({
					checkName: users?.data?.byUserId?.items[0]?.userName ? false : true,
					userName: users?.data?.byUserId?.items[0]?.userName,
					WebflowCustomerId: users?.data?.byUserId?.items[0]?.WebflowCustomerId,
				}),
			);
			setloader1(false);
			let nextToken = null;
			let items = [];
			try {
				const productImages = await API.graphql(
					graphqlOperation(productById, {
						id: user.attributes.sub,
						nextToken,
						limit: 100,
					}),
				);
				// do {
				// 	const productImages = await API.graphql(
				// 		graphqlOperation(productById, {
				// 			customerId: user.attributes.sub,
				// 			nextToken,
				// 			limit: 100,
				// 		}),
				// 	);
				// 	items = items.concat(
				// 		productImages.data.productById.items.sort(
				// 			(a, b) =>
				// 				new Date(b.createdAt).getTime() -
				// 				new Date(a.createdAt).getTime(),
				// 		),
				// 	);
				// 	nextToken = productImages.data.productById.nextToken;
				// } while (nextToken);
				dispatch(
					campaignData({
						campaign: productImages.data.productById,
					}),
				);
			} catch (error) {
				return error;
			}
		} catch (error) {
			seterrMsg(error.message);
			setTimeout(() => {
				seterrMsg("");
			}, 1500);
			if (error.message === "User is not confirmed.") {
				setAuthstate("confirmation");
			}
			setloader1(false);
		}
	}
	async function confirmSignUp() {
		setloader1(true);
		setmsg("");
		seterrMsg("");
		try {
			await Auth.confirmSignUp(email, verifycode);
			setloader1(false);
			setmsg(t("verifybtn"));
			setAuthstate("auth");
			setauth("signin");
			setVerifycode("");
			setEmail("");
			setpassword("");
			setTimeout(() => {
				setmsg("");
			}, 1500);
		} catch (error) {
			setloader1(false);
			seterrMsg(error.message);
		}
	}
	async function resendConfirmationCode() {
		setloader2(true);
		setmsg("");
		seterrMsg("");
		try {
			await Auth.resendSignUp(email);
			setmsg(t("codesend"));
			setloader2(false);
		} catch (err) {
			seterrMsg(err.message);
			setloader2(false);
		}
	}

	function forgotsend() {
		setloader2(true);
		setmsg("");
		seterrMsg("");
		Auth.forgotPassword(email)
			.then((data) => {
				setmsg(t("codesend"));
				setAuthstate("forgetpasswordcode");
				setloader2(false);
			})
			.catch((err) => {
				seterrMsg(err.message);
				setTimeout(() => {
					seterrMsg("");
				}, 1500);
				setloader2(false);
			});
	}
	function forgotcode() {
		setloader2(true);
		setmsg("");
		seterrMsg("");
		Auth.forgotPasswordSubmit(email, verifycode, password)
			.then((data) => {
				setmsg(t("new-passupdate"));
				setloader2(false);
				setAuthstate("auth");
				setauth("signin");
				setVerifycode("");
				setEmail("");
				setpassword("");
				seterrMsg("");
				setTimeout(() => {
					setmsg("");
				}, 1500);
			})
			.catch((err) => {
				seterrMsg(err.message);
				setloader2(false);
			});
	}

	return (
		<Container style={{ paddingLeft: "5px" }} className="container-width">
			<div className="auth-page-logo">
				<img src={Logo} alt="logo" />
			</div>
			<div className="auth-page-bottom">
				<Grid
					xs={12}
					lg={12}
					md={12}
					style={{ margin: width.width < 601 && "0 10px 0 10px" }}
				>
					{authstate === "auth" ? (
						<>
							<h2>{auth === "signin" ? t("sign_in") : t("sign_up")}</h2>
							<div>
								<p className="auth-type">
									<span
										className={auth === "signin" && "clr"}
										onClick={() => {
											setEmail("");
											setpassword("");
											setEmailError(false);
											setpasswordError(false);
											setauth("signin");
										}}
									>
										{t("sign_in")}
									</span>
									<span className="clr">|</span>
									<span
										className={auth === "signup" && "clr"}
										onClick={() => {
											setEmail("");
											setpassword("");
											setEmailError(false);
											setpasswordError(false);
											setauth("signup");
										}}
									>
										{t("sign_up")}
									</span>
								</p>
								<form
									onSubmit={
										auth === "signin" ? (e) => signIn(e) : (e) => signUp(e)
									}
								>
									{auth === "signup" && (
										<>
											<Inputfield
												type="text"
												value={userName}
												onChange={(e) => setUsername(e.target.value)}
												placeholder={t("username")}
											/>
											{auth !== "signin" && userNameError && userName && (
												<p className="errorclr">{t("usernameerr")}</p>
											)}
										</>
									)}
									<Inputfield
										type="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										placeholder={t("email")}
									/>
									{auth !== "signin" && emailerror && email && (
										<p className="errorclr">{t("emailerror")}</p>
									)}
									<Inputfield
										type="password"
										value={password}
										onChange={(e) => setpassword(e.target.value)}
										placeholder={t("password")}
									/>
									{auth !== "signin" && passwordError && password && (
										<p className="errorclr">{t("passworderror")}</p>
									)}
									<input type="submit" hidden />
								</form>
								<div className="auth-confirm" style={{ width: "103%" }}>
									<p
										className="forgetpassword"
										onClick={() => {
											setEmail("");
											setpassword("");
											setAuthstate("forgetpassword");
										}}
									>
										{t("forget_password")}
									</p>
									<Buttons
										text={
											auth === "signin"
												? `> ${t("sign_in")}`
												: `> ${t("sign_up")}`
										}
										onClick={
											auth === "signin" ? (e) => signIn(e) : (e) => signUp(e)
										}
										loader={loader1}
										className={"button signbtn"}
									/>
								</div>
							</div>
						</>
					) : authstate === "confirmation" ? (
						<>
							<h2>{t("auth-confirm")}</h2>
							<div>
								<p className="auth-type">
									<span className={"clr"}>{t("confirmcode")}</span>
								</p>
								<Inputfield
									type="number"
									value={verifycode}
									onChange={(e) => setVerifycode(e.target.value)}
									placeholder={t("verifycode")}
								/>
								<div className="auth-confirm" style={{ width: "103%" }}>
									<Buttons
										text={t("resendcode")}
										onClick={() => resendConfirmationCode()}
										className={"button signbtn"}
										loader={loader2}
									/>

									<Buttons
										text={`> ${t("verifybtn")}`}
										onClick={() => confirmSignUp()}
										className={"button signbtn"}
										loader={loader1}
									/>
								</div>
							</div>
						</>
					) : authstate === "forgetpassword" ? (
						<>
							<h2>{t("design_loding")}</h2>
							<div>
								<p className="auth-type">
									<span className={"clr"}>{t("enter-email")}</span>
								</p>
								<Inputfield
									type="email"
									value={email}
									onChange={(e) => setEmail(e.target.value)}
									placeholder={t("email")}
								/>
								<div className="auth-confirm" style={{ width: "103%" }}>
									<Buttons
										text={`> Retourner à la page de connexion`}
										onClick={() => setAuthstate("auth")}
										className="forgotbtn"
									/>
									<Buttons
										text={`> ${t("get")}`}
										onClick={() => forgotsend()}
										className={"button signbtn"}
										loader={loader2}
									/>
								</div>
							</div>
						</>
					) : authstate === "forgetpasswordcode" ? (
						<>
							<h2>{t("design_loding")}</h2>
							<div>
								<p className="auth-type">
									<span className={"clr"}>{t("confirmcode")}</span>
								</p>
								<Inputfield
									type="number"
									value={verifycode}
									onChange={(e) => setVerifycode(e.target.value)}
									placeholder={t("verifycode")}
								/>
								<Inputfield
									type="password"
									value={password}
									onChange={(e) => setpassword(e.target.value)}
									placeholder={t("new-password")}
								/>
								<div className="forgettbtn">
									<Buttons
										text={`> ${t("verifybtn")}`}
										onClick={() => forgotcode()}
										className={"button signbtn"}
										loader={loader2}
									/>
								</div>
							</div>
						</>
					) : null}
					{msg || errMsg ? (
						<Snackbar message={msg} errMessage={errMsg} />
					) : null}
				</Grid>
			</div>
		</Container>
	);
}
